<template>
    <v-flex xs12 text-xs-center>
        <h1 class="body-2 font-weight-light">Para utilizar esta función primero {{text}}.</h1>
        <div class="mt-3" >
            <v-btn round depressed v-if="backButton" color="secondary"  @click="$router.go(-1)">
                Volver
            </v-btn>
            <v-btn round depressed v-if="isOwner" color="primary white--text"  :to="{name: 'panel.provider.branches'}">
                Configurar sucursales
            </v-btn>
        </div>
    </v-flex>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        props:{
            backButton: {
                type: Boolean,
                default: false
            }
        },
        computed:{
            ...mapGetters(['isOwner']),
            text(){
                const vm = this
                return vm.isOwner ? 'debes configurar sucursales'
                    : 'el dueño de la cuenta empresa debe configurar sucursales'
            }
        }
    }
</script>

<style scoped>

</style>